import {Component} from 'react'
import NavBar from '../NavBar'
import Categories from '../Categories'
import Images from '../Images'
import './index.css'

class MatchGame extends Component {
  constructor(props) {
    super(props)
    const {imagesList} = props
    this.state = {
      timeLimit: 60,
      activeTabId: 'FRUIT',
      currentImg: imagesList[0],
      score: 0,
      isGameOver: false,
    }
  }

  componentDidMount() {
    this.startTimer()
  }

  componentWillUnmount() {
    clearInterval(this.timeId)
  }

  startTimer = () => {
    this.timeId = setInterval(this.decrement, 1000)
  }

  decrement = () => {
    this.setState(prevState => {
      if (prevState.timeLimit > 1) {
        return {timeLimit: prevState.timeLimit - 1}
      }
      clearInterval(this.timeId)
      return {timeLimit: 0, isGameOver: true}
    })
  }

  getRandomImage = () => {
    const {imagesList} = this.props
    const randomIndex = Math.floor(Math.random() * imagesList.length)
    return imagesList[randomIndex]
  }

  onClickCatogory = tabId => {
    this.setState({activeTabId: tabId})
  }

  onClickImage = id => {
    const {currentImg} = this.state
    if (currentImg.id === id) {
      this.setState(prevState => ({
        score: prevState.score + 1,
        currentImg: this.getRandomImage(),
      }))
    } else {
      clearInterval(this.timeId)
      this.setState({timeLimit: 0, isGameOver: true})
    }
  }

  onClickPlayAgain = () => {
    clearInterval(this.timeId)
    const {imagesList} = this.props
    this.startTimer()
    this.setState({
      timeLimit: 60,
      score: 0,
      isGameOver: false,
      currentImg: imagesList[0],
      activeTabId: 'FRUIT',
    })
  }

  render() {
    const {tabsList, imagesList} = this.props
    const {timeLimit, activeTabId, currentImg, score, isGameOver} = this.state

    const filteredList = imagesList.filter(
      each => each.category === activeTabId,
    )

    return (
      <div className="bgContainer">
        <NavBar timeLimit={timeLimit} score={score} />

        {isGameOver ? (
          <div className="container">
            <div className="timeUpContainer">
              <img
                src="https://assets.ccbp.in/frontend/react-js/match-game-trophy.png"
                alt="trophy"
                className="tropyImg"
              />
              <p>YOUR SCORE</p>
              <p className="scores">{score}</p>
              <button
                className="playAgainBtn"
                type="button"
                onClick={this.onClickPlayAgain}
              >
                <img
                  src="https://assets.ccbp.in/frontend/react-js/match-game-play-again-img.png"
                  alt="reset"
                  className="resetImg"
                />
                PLAY AGAIN
              </button>
            </div>
          </div>
        ) : (
          <div className="gameContainer">
            <div>
              <img className="img" src={currentImg?.imageUrl} alt="match" />
            </div>
            <ul className="categoryContainer">
              {tabsList.map(each => (
                <Categories
                  key={each.tabId}
                  tabsList={each}
                  onClickCatogory={this.onClickCatogory}
                  activeTabId={activeTabId}
                />
              ))}
            </ul>
            <ul className="imgContainer">
              {filteredList.map(each => (
                <Images
                  key={each.id}
                  imagesList={each}
                  onClickImage={this.onClickImage}
                />
              ))}
            </ul>
          </div>
        )}
      </div>
    )
  }
}

export default MatchGame
